/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamsModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ITeamAwareState } from "Tfs/ReduxCommon/Modules/Teams/TeamContracts";
import { teamReducer } from "Tfs/ReduxCommon/Modules/Teams/TeamReducer";
import { teamSaga } from "Tfs/ReduxCommon/Modules/Teams/TeamSaga";

export function getTeamModule(): ISagaModule<ITeamAwareState> {
    const reducerMap: ReducersMapObject<ITeamAwareState, AnyAction> = {
        teamState: teamReducer
    };

    return {
        id: "teams",
        reducerMap,
        sagas: [teamSaga]
    };
}
